import { useRef, useCallback } from 'react';
import { toast } from 'sonner';
import { hapticError } from '@/utils/haptic';

export function useClickRateLimit(options = {}) {
  const {
    maxClicks = 4,
    windowMs = 2000,
    cooldownMs = 1500,
    message = "Slow down there partner! 🤠"
  } = options;

  const clickTimestamps = useRef([]);
  const cooldownActive = useRef(false);

  const checkRateLimit = useCallback((e) => {
    const now = Date.now();
    
    // Remove clicks older than window
    clickTimestamps.current = clickTimestamps.current.filter(t => now - t < windowMs);
    clickTimestamps.current.push(now);
    
    // If too many clicks, block and show warning
    if (clickTimestamps.current.length >= maxClicks) {
      if (e && e.preventDefault) {
        e.preventDefault();
      }
      
      if (!cooldownActive.current) {
        cooldownActive.current = true;
        hapticError();
        toast.warning(message);
        
        setTimeout(() => {
          cooldownActive.current = false;
          clickTimestamps.current = [];
        }, cooldownMs);
      }
      
      return true; // Rate limited
    }
    
    return false; // Not rate limited
  }, [maxClicks, windowMs, cooldownMs, message]);

  const isBlocked = useCallback(() => {
    return cooldownActive.current;
  }, []);

  const reset = useCallback(() => {
    clickTimestamps.current = [];
    cooldownActive.current = false;
  }, []);

  return { checkRateLimit, isBlocked, reset };
}
